import { convertRestIdToEwsId } from 'owa-identifiers';
import { getQueryStringParameter } from 'owa-querystring';
import { type MailRouteType } from '../schema/MailRouteType';
import { setMailRoute } from '../action/setMailRoute';

export interface MailRouteHandlerParams {
    itemId?: string;
}

/**
 * Set the appropriate route store values based on the URL that is loaded
 * This is called on page refresh or hardware back
 * @param routeParams
 */
export const mailDeepLinkReadItemRouteHandler = async (routeParams: MailRouteHandlerParams) => {
    // setMailRoute to MailRouteType.deeplinkReadItem if:
    // 1. Route matches to /read/itemId
    // 2. GraphApi deep-link matches, then extract the itemId from the query param
    const itemId = routeParams?.itemId || getQueryStringParameter('ItemID');
    if (itemId) {
        const ewsId = convertRestIdToEwsId(itemId);
        return setMailRoute('deeplinkReadItem', ewsId);
    }
};

/**
 * Set the appropriate route store values based on the URL that is loaded
 * This is called on page refresh or hardware back
 * @param routeParams
 */
export const manageAccountsRouteHandler = async (routeParams: MailRouteHandlerParams) => {
    // setMailRoute to MailRouteType.manageAccounts if:
    // 1. Route matches to /manage-accounts/itemId
    // 2. Route matches to /manage-accounts
    const itemId = routeParams?.itemId;
    return setMailRoute('manageAccounts', itemId);
};

/**
 * Returns a route handler function for handling direct landing on the given MailRouteType
 * The handler is called on page refresh or hardware back
 */
export function getHandlerForMailRoute(route: MailRouteType) {
    return async (routeParams?: MailRouteHandlerParams): Promise<void> => {
        switch (route) {
            case 'deeplinkReadItem': {
                return mailDeepLinkReadItemRouteHandler(routeParams);
            }
            case 'manageAccounts': {
                return manageAccountsRouteHandler(routeParams);
            }
            default:
                return setMailRoute(route);
        }
    };
}

/**
 * Reset the route store on moving away from the route
 */
export const mailRouteCleanup = async () => {
    setMailRoute(null, null);

    // exit the route
    return false;
};
